import { createHttpClient } from '../utils/httpUtils';
import * as Sentry from '@sentry/react';

class TreePaneViewService {
  constructor() {
    this.http = createHttpClient();
  }

  async create(setting) {
    const res = await this.http.post('treePaneView', setting).catch((error) => {
      console.log(error.response);
      return false;
    });
    return res ? res.data : res;
  }

  async update(settingId, setting) {
    const res = await this.http
      .put('treePaneView/' + settingId, setting)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async selectedActivityTreeByDateRange(data) {
    try {
      const res = await this.http.post(
        'treePaneView/update/activities-by-range',
        data
      );
      return res ? res.data : res;
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setContext('selected activity tree by date range', {
          message: error.message
        });
        Sentry.captureException(error);
      });

      throw error;
    }
  }

  async hideActivity(viewId, activityId) {
    const res = await this.http.patch(
      `treePaneView/view/${viewId}/activity/${activityId}`,
      {
        hide: true
      }
    );
    return res ? res.data : res;
  }
}

export const treePaneService = new TreePaneViewService();
